import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeyFactory } from '../utils/queryKeyFactory';
import { APIClinicBalance } from 'lib/api/firebase/apis/api-clinic-balance';

export function useSetProductSupportsOnDemandPurchasesMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: APIClinicBalance.setProductSupportsOnDemandPurchases,
    onSuccess: async (_in, variables) => {
      await queryClient.invalidateQueries({
        queryKey: queryKeyFactory.billingSettings.details()
      });
      await queryClient.invalidateQueries({
        queryKey: queryKeyFactory.clinic.assessmentBalance(
          variables?.clinicId ?? '',
          variables?.type ?? ''
        )
      });
    }
  });
}
